import { render, staticRenderFns } from "./CurationFilterSendLayout.vue?vue&type=template&id=241d288c&scoped=true&"
import script from "./CurationFilterSendLayout.vue?vue&type=script&lang=js&"
export * from "./CurationFilterSendLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d288c",
  null
  
)

export default component.exports